var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showPdas)?[_c(_vm.componentName,{tag:"component"})]:[_c('add')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }